<div class="yllw-form-field">
    <div class="field-with-prefix">
        <i class="pi pi-briefcase prefix-icon"></i>
        <p-floatlabel variant="on" class="flex-1">
            <!-- Not [loading]: the select ignores clicks while loading, and Attio can take a few seconds -->
            <p-select
                inputId="attioDeal"
                [formControl]="control()"
                [options]="choices()"
                optionLabel="name"
                dataKey="recordId"
                optionDisabled="disabled"
                [filter]="true"
                filterBy="name,companyName"
                [dropdownIcon]="isLoading() ? 'pi pi-spinner pi-spin' : undefined"
                [emptyMessage]="emptyMessageKey() | translate"
                [emptyFilterMessage]="'COMMON.NO_RESULTS' | translate"
                appendTo="body"
                styleClass="w-full"
                >
                <ng-template let-deal #item>
                    <div class="flex flex-column w-full">
                        <span>{{ deal.name }}</span>
                        <span class="option-info-text">
                            {{ deal.companyName ?? ('ATTIO_DEAL_PICKER.NO_COMPANY' | translate) }}
                            @if (deal.stage) {
                                · {{ deal.stage }}
                            }
                            @if (deal.disabled) {
                                · {{ 'ATTIO_DEAL_PICKER.NO_CUSTOMER_CODE' | translate }}
                            }
                        </span>
                    </div>
                </ng-template>
                <ng-template #empty>
                    <div class="flex flex-column gap-1">
                        <span>{{ emptyMessageKey() | translate }}</span>
                        @if (hasNoOpenDeals() && attioDealsUrl(); as dealsUrl) {
                            <a [href]="dealsUrl" target="_blank" rel="noopener">
                                {{ 'ATTIO_DEAL_PICKER.OPEN_DEALS_IN_ATTIO' | translate }}
                                <i class="pi pi-external-link text-xs ml-1" aria-hidden="true"></i>
                            </a>
                        }
                    </div>
                </ng-template>
                <!-- A deal made in Attio after the list loaded shows up without leaving the form -->
                <ng-template #footer>
                    @if (hasSalesPerson()) {
                        <div class="flex justify-content-end px-2 pb-2">
                            <p-button
                                [label]="'COMMON.REFRESH' | translate"
                                icon="pi pi-refresh"
                                [text]="true"
                                size="small"
                                [disabled]="isLoading()"
                                (click)="load()" />
                        </div>
                    }
                </ng-template>
                <ng-template #selectedItem let-deal>
                    @if (deal) {
                        <span>{{ deal.name }}@if (deal.companyName) { — {{ deal.companyName }}}</span>
                    }
                </ng-template>
            </p-select>
            <label for="attioDeal">{{ "ATTIO_DEAL_PICKER.LABEL" | translate }}</label>
        </p-floatlabel>
    </div>
    @if (errorMessage(); as message) {
        <div class="flex align-items-center gap-2 mt-2">
            <small class="text-error" [innerHTML]="message"></small>
            <p-button [label]="'RETRY' | translate" [text]="true" size="small" (click)="load()" />
        </div>
    }
    <app-core-errors [control]="control()"></app-core-errors>
</div>
